import { render, staticRenderFns } from "./MainLifeRiderWidget.vue?vue&type=template&id=cd77f5ac&scoped=true"
import script from "./MainLifeRiderWidget.vue?vue&type=script&lang=js"
export * from "./MainLifeRiderWidget.vue?vue&type=script&lang=js"
import style0 from "./MainLifeRiderWidget.vue?vue&type=style&index=0&id=cd77f5ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd77f5ac",
  null
  
)

export default component.exports